import $ from 'jquery';
import CookiesConsent from './components/cookies-consent'
import './components/gallery';
import './components/ajax-references';
import './components/tabs';
import './components/testimonies-slider';
import './components/menu-handler';
import './components/references-read-more';
import './components/animations';
import './components/single-formations';

jQuery(document).ready(function( $ ){

  $("#slider-logos > div:gt(0)").hide();

  setInterval(function() {
    $('#slider-logos > div:first')
      .fadeOut(1000)
      .next()
      .fadeIn(1000)
      .end()
      .appendTo('#slider-logos');
  },  4000);

  var topBar = $('aside.top-bar');
  var topBarHeight = topBar.outerHeight();
  var coordonnees = $('.coordonnees');
  var coordonneesHeight = coordonnees.outerHeight();
  var navBar = $('header nav');
  var navBarHeight = navBar.outerHeight();
  var paddingTop = coordonneesHeight + navBarHeight;

  // console.log('H. coordonnées: ' + coordonneesHeight + ' - H. nav: ' + navBarHeight + ' TOTAL: ' + paddingTop);

  $(window).scroll(function() {

    if( $('body').hasClass('home') ) {
      var scroll = $(window).scrollTop();
      if (scroll >= 500) {
          $("nav").addClass("sticky");
          $(".coordonnees").addClass("sticky");
      } else {

        $("nav").removeClass("sticky");
        $(".coordonnees").removeClass("sticky");

      }
    } else {
      var scroll = $(window).scrollTop();
      if (scroll >= 70) {
          $("header.main-header").css('margin-top', paddingTop + 'px');
          $("nav").addClass("sticky");
          $("nav").removeClass("no-sticky");

          $(".coordonnees").addClass("sticky");
          $(".coordonnees").removeClass("no-sticky");
      } else {
          $("header.main-header").css('margin-top', 0);
          $("nav").removeClass("sticky");
          $("nav").addClass("no-sticky");

          $(".coordonnees").removeClass("sticky");
          $(".coordonnees").addClass("no-sticky");
      }
    }
  });

  $('.flex-2-col .img-col a').colorbox({
    rel: "lightbox",
    closeButton: true,
    maxWidth: "90%",
  });

  // Slider page accueil
  var $slider = $('#slider').slick({
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    arrows: true,
    dots: true,
    nextArrow: $('.next'),
    prevArrow: $('.prev'),
  });

  $('.home .slider .slick-arrow').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
  });

  // Slider page accueil
  var $slider = $('#slider-temoignages').slick({
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"><span class="screen-reader-text">Précédent</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span class="screen-reader-text">Suivant</span></button>',
    dots: false,
  });


  // Cookie consent
  if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
    // Tarteaucitron cookie settings
    let tarteaucitronLang = '';
    switch(document.documentElement.lang) {
      case 'fr-FR':
      tarteaucitronLang = 'fr';
      break;
      case 'en-EN':
      tarteaucitronLang = 'en';
      break;
      default:
        tarteaucitronLang = 'fr';
    }

    const cookiesConsent = new CookiesConsent(tarteaucitronLang, false);
  }

  // Accordéons
  $('.accordion__title-button').click(function() {
      var $this = $(this);
      var $parent = $this.parent('.accordion');
      var $openedBoxes = $('.accordion.active');
      var $accordionOpened = $openedBoxes.children('.accordion__title');

      if($this.attr("aria-expanded") === "true") {
        $this.attr("aria-expanded", "false")
      } else {
        $this.attr("aria-expanded", "true")
      }

      if($parent.length) {
        $('.accordion__content').removeClass('active');

        if($openedBoxes.length) {
          $openedBoxes.each(function(index, box) {
            if(box === $parent[0]) {
              $openedBoxes.splice(index, 1);
            }
          });
          if($openedBoxes.length) {
            $openedBoxes.removeClass('active');
            $accordionOpened.attr("aria-expanded", "false");
          }
        }
        $parent.toggleClass('active');
      }
  });

  $('.testimonies-section__list').slick({
      dots: true,
      appendDots: $('.testimnoies-section__dots'),

      prevArrow: $('.testimonies-section__prev'),
      nextArrow: $('.testimonies-section__next'),
  });

  $('.references-list-slider').on('init setPosition afterChange', function () {
      $(this).find('.slick-slide').each(function () {
          const $slide = $(this);
          const hidden = $slide.attr('aria-hidden') === 'true';

          // Le slide lui-même ne doit jamais être focusable
          $slide.removeAttr('tabindex');

          // Les boutons des slides cachées ne doivent pas être focusables
          $slide.find('button').attr('tabindex', hidden ? '-1' : '0');
      });
  });

  $('.references-list-slider').slick({
      dots: false,
      slidesToShow: 2.5,
      slidesToScroll: 1,
      centerMode: false,
      infinite: false,

      responsive: [
          {
              breakpoint: 992,
              settings: {
                  slidesToShow: 1.5,
                  slidesToScroll: 1
              }
          }
      ]
  });

});



